import { useInvalidFundingSources } from '@melio/ap-domain';
import { BrandSymbolKey, IconKey } from '@melio/penny';
import { FsTypeOption, FundingSource } from '@melio/platform-api';
import { useConfig } from '@melio/platform-provider';

import { getFundingSourceIconByNetwork, getFundingSourceIconByType } from '../components';

export const getFundingSourceIconKey = (
  fundingSource: FundingSource,
  icon: IconKey | BrandSymbolKey
): IconKey | BrandSymbolKey => {
  const { type: fundingType } = fundingSource;

  if (fundingType === 'bank-account') {
    return getFundingSourceIconByType({ fundingType, bankIcon: icon });
  }

  const { network, type: cardType } = fundingSource.details;
  return network
    ? getFundingSourceIconByNetwork(network)
    : getFundingSourceIconByType({ fundingType, bankIcon: icon, cardType });
};

export const useFundingSourceIconKey = (fundingSource: FundingSource): IconKey | BrandSymbolKey => {
  const { settings } = useConfig();
  return getFundingSourceIconKey(fundingSource, settings.icons.fundingSource.bank);
};

export const useFundingSourcesIconKeys = (fundingSources: FundingSource[]) => {
  const { settings } = useConfig();
  return fundingSources.map((fundingSource) => ({
    fundingSource,
    icon: getFundingSourceIconKey(fundingSource, settings.icons.fundingSource.bank),
  }));
};

export const useFundingSourcesSelectOptions = (
  fundingSources: FundingSource[],
  paymentFundingSourceTypesOptions?: FsTypeOption[]
) => {
  const { getFundingSourceTooltip, getIsValidFundingSource } = useInvalidFundingSources(
    paymentFundingSourceTypesOptions
  );
  const { settings } = useConfig();

  return fundingSources.map((fundingSource) => ({
    label: fundingSource.displayName,
    value: fundingSource.id,
    testId: fundingSource.id,
    icon: getFundingSourceIconKey(fundingSource, settings.icons.fundingSource.bank),
    disabled: {
      isDisabled: !getIsValidFundingSource(fundingSource),
      message: getFundingSourceTooltip(fundingSource),
    },
  }));
};
